import { compose, lifecycle, withHandlers } from 'recompose';
import { pickBy, isEqual } from 'lodash';
import { scrollToElement } from '@sparefoot/react-core/utils/scrolling';
import { parse } from 'query-string';

import { buildSearchLink } from 'utils/search';

export default compose(
	withHandlers({
		onSearch: ({ actions, history, searchParams }) => (filterValues, delayFiltering = false) => {
			// Merge in any new filters and filter out any false filters
			const params = pickBy({ ...searchParams, page: 1, ...filterValues });
			actions.updateSearchFilters(params);
			if (!delayFiltering) {
				history.push({ search: buildSearchLink(params) });
			}
		}
	}),
	lifecycle({
		componentDidUpdate(prevProps) {
			const { actions, loading, location, page } = this.props;

			// Do another search if the query params changed
			if (location.search && !isEqual(location.search, prevProps.location.search)) {
				const query = parse(location.search, { arrayFormat: 'bracket' });
				actions.getSearchResults(query, location.key);
			}

			// Only scroll to the top if the page changes
			if (prevProps.loading && !loading && (page !== prevProps.page)) {
				scrollToElement('#search-page-results', { offset: -16 });
			}
		}
	})
);
